import { ChevronLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

/** Page title (26/600) with an optional back link and an action on the end side. */
export function PageHeader({
  title,
  back,
  action,
}: {
  title: string;
  back?: string;
  action?: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <div className="mb-1 flex flex-col gap-2">
      {back && (
        <Link
          to={back}
          className="-ms-1 inline-flex min-h-11 w-fit items-center gap-1 rounded-xl pe-2 text-[15px] font-medium text-accent focus-visible:outline-2 focus-visible:outline-accent"
        >
          <ChevronLeft aria-hidden="true" className="size-5 rtl:rotate-180" strokeWidth={2} />
          {t('common.back')}
        </Link>
      )}
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-[26px] leading-tight font-semibold">{title}</h1>
        {action}
      </div>
    </div>
  );
}
